module.exports = __webpack_public_path__ + "static/img/folkSong_wx.a28ff98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/folkSong_wx.png
// module id = VUFl
// module chunks = 26